import { AxiosError } from 'axios';
import type { ApiError } from '@/shared/types/api/common';
import i18n from '@/shared/lib/i18n';

export const isApiError = (err: unknown): err is AxiosError<ApiError> =>
  err instanceof AxiosError;

export const extractErrorMessage = (err: unknown, fallback?: string): string => {
  const fallbackMessage = fallback ?? i18n.t('common:errorGeneric');
  if (!isApiError(err)) {
    if (err instanceof Error) return err.message;
    return fallbackMessage;
  }
  const data = err.response?.data;
  if (data?.message) return data.message;
  if (data?.errors) {
    const first = Object.values(data.errors)[0];
    if (Array.isArray(first) && first.length > 0 && typeof first[0] === 'string') {
      return first[0];
    }
  }
  return err.message || fallbackMessage;
};

export const extractFieldErrors = (err: unknown): Record<string, string> => {
  if (!isApiError(err)) return {};
  const errors = err.response?.data?.errors;
  if (!errors) return {};
  const result: Record<string, string> = {};
  for (const [field, messages] of Object.entries(errors)) {
    if (Array.isArray(messages) && messages.length > 0 && typeof messages[0] === 'string') {
      result[field] = messages[0];
    }
  }
  return result;
};
